import React, { useState, useEffect, useRef } from "react";

import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import { Link } from "react-router-dom";
import moment from "moment";
import LinesEllipsis from "react-lines-ellipsis";
import Loading from "../../../components/loading";
import { getData } from "../../../services/getService";

import img1 from "./../../../assets/img/02-2025/1_0.png";
import img2 from "./../../../assets/img/02-2025/2_0.png";
import img3 from "./../../../assets/img/02-2025/3_0.png";
import img4 from "./../../../assets/img/02-2025/4_0.png";
import img5 from "./../../../assets/img/02-2025/5_0.png";
import img6 from "./../../../assets/img/02-2025/6_0.png";
import img7 from "./../../../assets/img/02-2025/7_0.png";
import img8 from "./../../../assets/img/02-2025/8_0.png";
import imgBanner from "./../../../assets/img/sep-ed/2026/banner.jpg";

import Modalgallery from "./../../../components/modalSrc";

import sornUp from "./../../../assets/img/icon/sorn-up.svg";

// --- ใช้ require.context ดึงรูปทั้งหมดจากโฟลเดอร์ gallery ---
const galleryContext = require.context(
  "./../../../assets/img/sep-ed/2026/gallery",
  false,
  /\.(png|jpe?g|svg)$/i
);

// Map ข้อมูลออกมาเป็น Array ของ URL รูปภาพ
const gel = galleryContext.keys().map((item) => {
  const image = galleryContext(item);
  return image.default || image; // เผื่อกรณี Webpack คืนค่ามาเป็น Module Object
});

const Main = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataOne, setDataOne] = useState({});

  const [dataS, setDataS] = useState(null);

  const [modalgallery, setModalgallery] = useState({ view: false });

  const [mainData, setMainData] = useState({ photo: gel });

  const called = useRef(true);

  useEffect(() => {
    if (called.current) {
      Promise.all([fetchDataOne()]).then((res) => {
        setIsLoading(false);
      });
    }
    return () => {
      called.current = false;
    };
  }, []);

  const fetchDataOne = async () => {
    getData("pageawards", "ed")
      .then((response) => {
        if (response.status === "success") {
          setDataOne(response.data);
        }
      })
      .catch((e) => {
        console.log(e.response.data.error);
      });
  };

  return (
    <>
      <div id="outer-container" style={{}}>
        <Header page="activities" sub="capacity" />
        <div className="wrapper bg-white box-index">
          {isLoading ? <Loading /> : null}
          <section className="pb-md-5 bg-top">
            <div className="container-fluid">
              <div className="row justify-content-center text-start">
                <div className="col-12 col-md-12 col-lg-12 p-0">
                  <div className="">
                    <img
                      src={
                        process.env.REACT_APP_IMG_LINK +
                        "/uploads/awards/" +
                        dataOne.id +
                        "/" +
                        dataOne.img
                      }
                      className="w-100 rounded"
                    />
                  </div>
                </div>
                <div className="col-12 col-md-12 col-lg-9 mt-md-4">
                  <div className="font-60 weight-700">{dataOne.topic}</div>
                  <div className="mb-5 pt-3">
                    <div
                      className="text-justify font-18 content-custom"
                      dangerouslySetInnerHTML={{
                        __html: dataOne.detail,
                      }}
                    />
                  </div>

                  <div>
                    <table className="w-100 table table-borderless align-self-start mb-0">
                      <tr>
                        <td className="align-top">
                          <a
                            href="#"
                            className=""
                            style={{ textDecoration: " none", color: "unset" }}
                          >
                            <div className="text-center">
                              <h4
                                className="weight-700 h4-respon"
                                style={{ marginBottom: "-20px" }}
                              >
                                SEP-ED
                              </h4>
                              <img src={img1} className="w-75 py-5" />
                            </div>
                          </a>
                        </td>
                        <td>
                          <div className="text-center">
                            <img src={img4} className="w-50" />
                          </div>
                        </td>
                        <td className="align-top">
                          <a
                            href="/activities/capacitySep4school"
                            className=""
                            style={{ textDecoration: " none", color: "unset" }}
                          >
                            <div className="text-center">
                              <h4
                                className="weight-700 h4-respon"
                                style={{ marginBottom: "-25px" }}
                              >
                                SEP4School
                              </h4>
                              <img src={img2} className="w-100 pt-3 pt-md-0" />
                            </div>
                          </a>
                        </td>
                        <td>
                          <div className="text-center">
                            <img src={img4} className="w-50" />
                          </div>
                        </td>
                        <td className="align-top">
                          <a
                            href="/activities/capacitySepRegionalYouthCamp"
                            className=""
                            style={{ textDecoration: " none", color: "unset" }}
                          >
                            <div className="text-center">
                              <h4
                                className="weight-700 h4-respon"
                                style={{ marginBottom: "-5px" }}
                              >
                                SEP Student Camp
                              </h4>
                              <img src={img3} className="w-100" />
                            </div>
                          </a>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center py-3 py-md-5 text-start">
                <div className="col-11 col-md-9 col-lg-9">
                  <div>
                    <div>
                      <img src={imgBanner} className="w-100" />
                    </div>
                    <div className="mt-3">
                      <p className="text-justify font-18 content-custom">
                        The third SEP-ED seminar brought to life the powerful links between cultural heritage and the Sufficiency Economy Philosophy (SEP) as strong foundations for sustainable development. Across Southeast Asia, cultural heritage continues to thrive as a living source of knowledge, values, and practices that closely reflect SEP principles of moderation, reasonableness, and resilience, enabling communities to pursue more balanced and inclusive growth. The seminar actively explored these connections, deepening participants’ understanding of how safeguarding and promoting heritage can strengthen community identity and enhance overall well-being. It also showcased how traditional practices can be effectively integrated with modern approaches, creating rich and practical learning resources for today’s challenges.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center pb-md-5 text-start">
                <div className="col-12 col-md-12 col-lg-9">
                  <div className="mb-4">
                    <div className="row justify-content-center text-start">
                      <div className="col-6 col-md-3 col-lg-3">
                        <button
                          className="btn text-center"
                          onClick={(e) => setDataS(1)}
                        >
                          <img src={img5} className="w-75 px-4" />
                          <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                            Objectives
                          </h4>
                        </button>
                      </div>
                      <div className="col-6 col-md-3 col-lg-3">
                        <button
                          className="btn text-center"
                          onClick={(e) => setDataS(2)}
                        >
                          <img src={img6} className="w-75 px-4" />
                          <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                            Participants
                          </h4>
                        </button>
                      </div>
                      <div className="col-6 col-md-3 col-lg-3">
                        <a
                          href="https://drive.google.com/file/d/1nFP19bVo0j36CB9halvJipnFJoG-8NwB/view?usp=drive_link"
                          target={"_blank"}
                          className="btn text-center"
                        >
                          <img src={img7} className="w-75 px-4" />
                          <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                            Programme
                          </h4>
                        </a>
                      </div>
                      <div className="col-6 col-md-3 col-lg-3">
                        <a
                          href="https://drive.google.com/file/d/1pKAfxLYlhvC_AQP8dnxYNRSKkKC8E8BO/view?usp=drive_link"
                          target={"_blank"}
                          className="btn text-center"
                        >
                          <img src={img8} className="w-75 px-4" />
                          <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                            Document
                          </h4>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="d-none d-md-block">
                      <div
                        className="row text-start"
                        style={{ marginBottom: "-20px" }}
                      >
                        <div className="col-12 col-md-3 col-lg-3 text-center">
                          {dataS === 1 && (
                            <img
                              src={sornUp}
                              className=""
                              style={{
                                width: "50px",
                                filter:
                                  "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)",
                              }}
                            />
                          )}
                        </div>
                        <div className="col-12 col-md-3 col-lg-3 text-center">
                          {dataS === 2 && (
                            <img
                              src={sornUp}
                              className=""
                              style={{
                                width: "50px",
                                filter:
                                  "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)",
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    {dataS === 1 ? (
                      <div
                        className="p-4"
                        style={{ background: "#FFDE59", borderRadius: "15px" }}
                      >
                        <ol>
                          <li>
                            Provide a platform to explore SEP and culture as a
                            valuable framework for building stronger,
                            self-reliant and more resilient communities.
                          </li>
                          <li>
                            Identify best practices by showcasing creative and
                            innovative applications of SEP in schools and
                            communities that integrate education, local heritage
                            and entrepreneurship in to curricula.
                          </li>
                          <li>
                            Build the foundations for a supportive, inter-agency
                            community of officials, educators and relevant
                            partners for long-term alliance in culture and
                            heritage sustainability through education.
                          </li>
                        </ol>
                      </div>
                    ) : dataS === 2 ? (
                      <div
                        className="p-4"
                        style={{ background: "#FFDE59", borderRadius: "15px" }}
                      >
                        A total 17 mid to senior level officials from 9
                        countries joined the SEP-ED programme. Of them 15 were
                        from 8 SEAMEO Member Countries – Brunei Darussalam,
                        Indonesia, Lao PDR, Malaysia, Myanmar, Philippines,
                        Thailand and Vietnam – and 2 were from Bhutan. They
                        represented diverse sectors including education, arts,
                        culture, heritage, tourism, and religious affairs,
                        reflecting a strong commitment to holistic,
                        cross-sectoral collaboration in advancing sustainable
                        development.
                      </div>
                    ) : null}
                  </div>
                  {/* <div className="row justify-content-center pb-md-5 pt-md-5 mt-5 text-start">
                    <div className="col-12 col-md-8 col-lg-8">
                      <div className="d-none d-md-block">
                        <iframe
                          width="100%"
                          height="515"
                          src="https://www.youtube.com/embed/m_OW5psWlkc?si=gn7rS7hZwNw0iYkp"
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          allowFullScreen
                        ></iframe>
                      </div>
                      <div className="d-block d-md-none">
                        <iframe
                          width="100%"
                          height="210"
                          src="https://www.youtube.com/embed/m_OW5psWlkc?si=gn7rS7hZwNw0iYkp"
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  </div> */}

                  {dataOne.news && dataOne.news.length ? (
                    <div>
                      <div className="topic mb-4 mt-5">News</div>
                      <div className="row">
                        {dataOne.news
                          .sort(
                            (a, b) =>
                              new Date(b.dateActive) - new Date(a.dateActive)
                          )
                          .map((val, index) => (
                            <div
                              className="col-12 col-md-4 col-lg-4"
                              key={index}
                            >
                              <Link
                                to={"/newsandgallery/news/" + val.newsId}
                                className="a-news pb-4 mb-4 mb-md-5"
                              >
                                <div className="row text-start">
                                  <div className="col-12 col-md-12 col-lg-12">
                                    <div>
                                      <img
                                        src={
                                          process.env.REACT_APP_IMG_LINK +
                                          "/uploads/news/" +
                                          val.newsId +
                                          "/" +
                                          val.banner
                                        }
                                        className="w-100 rounded"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-12 col-lg-12">
                                    <div className="font-14 mt-2">
                                      {moment(val.dateActive).format(
                                        "D MMMM Y"
                                      )}
                                    </div>

                                    <div
                                      className="news-topic mt-3 mt-md-0"
                                      dangerouslySetInnerHTML={{
                                        __html: val.topic,
                                      }}
                                    />
                                    <div className="mt-4">
                                      <LinesEllipsis
                                        text={val.subTopic}
                                        maxLine="3"
                                        ellipsis="..."
                                        trimRight
                                        basedOn="letters"
                                      />
                                    </div>
                                    <div className="mt-3">
                                      <a style={{ color: "#e6c12f" }}>
                                        Read More
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          ))}
                      </div>
                    </div>
                  ) : null}

                  <div className="topic mb-3">Gallery</div>
                  <div>
                    {/* --- จุดที่ 2: เปลี่ยนจากการเรียก g1, g2... เป็น mainData.photo[0] --- */}
                    <div className="d-flex gap-1 gap-md-2">
                      <div
                        onClick={() =>
                          setModalgallery({
                            view: true,
                            gallery: mainData.photo,
                            dataUrl: mainData.photo[0],
                            active: 0,
                          })
                        }
                      >
                        <img
                          src={mainData.photo[0]}
                          className="w-100 cursor-pointer"
                        />
                      </div>
                      <div
                        onClick={() =>
                          setModalgallery({
                            view: true,
                            gallery: mainData.photo,
                            dataUrl: mainData.photo[1],
                            active: 1,
                          })
                        }
                      >
                        <img
                          src={mainData.photo[1]}
                          className="w-100 cursor-pointer"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mt-1 mt-md-2 mb-5">
                    <div className="d-flex gap-1 gap-md-2">
                      <div
                        onClick={() =>
                          setModalgallery({
                            view: true,
                            gallery: mainData.photo,
                            dataUrl: mainData.photo[2],
                            active: 2,
                          })
                        }
                      >
                        <img
                          src={mainData.photo[2]}
                          className="w-100 cursor-pointer"
                        />
                      </div>
                      <div
                        onClick={() =>
                          setModalgallery({
                            view: true,
                            gallery: mainData.photo,
                            dataUrl: mainData.photo[3],
                            active: 3,
                          })
                        }
                      >
                        <img
                          src={mainData.photo[3]}
                          className="w-100 cursor-pointer"
                        />
                      </div>
                      <div
                        className="cursor-pointer position-relative"
                        onClick={() =>
                          setModalgallery({
                            view: true,
                            gallery: mainData.photo,
                            dataUrl: mainData.photo[4],
                            active: 4,
                          })
                        }
                      >
                        <img src={mainData.photo[4]} className="w-100" />
                        <div
                          className="position-absolute absolute-center-center w-100 h-100"
                          style={{ background: "rgba(0,0,0,.4)" }}
                        >
                          <h1 className="position-absolute absolute-center-center text-white">
                            +{mainData.photo.length - 5}
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="topic mb-3">Previous Activities</div>
                  <div className="mb-5">
                    <a
                      href="/newsandgallery/archivesOpacity/8"
                      className="btn btn-watch-passtel font-16 px-5 py-2"
                    >
                      2025
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <Footer page="activities" sub="capacity" />
        </div>
      </div>

      {modalgallery.view ? (
        <Modalgallery
          show={modalgallery.view}
          onHide={() => setModalgallery({ view: false })}
          dataUrl={modalgallery.dataUrl}
          gallery={modalgallery.gallery}
          active={modalgallery.active}
        />
      ) : null}
    </>
  );
};

export default Main;
